import React from 'react';
import './SkeletonLoader.css';

function SkeletonLoader({ type = 'default', count = 1, height, width, className = '' }) {
    const renderSkeleton = () => {
        switch (type) {
            case 'requirements-panel':
                return (
                    <div className="skeleton-requirements-panel">
                        <div className="skeleton-header">
                            <div className="skeleton-icon"></div>
                            <div className="skeleton-title"></div>
                        </div>
                        <div className="skeleton-selector"></div>
                        <div className="skeleton-question-details">
                            <div className="skeleton-question-title"></div>
                            <div className="skeleton-question-desc"></div>
                            <div className="skeleton-question-desc short"></div>
                            <div className="skeleton-badge"></div>
                        </div>
                        <div className="skeleton-tabs">
                            <div className="skeleton-tab"></div>
                            <div className="skeleton-tab"></div>
                            <div className="skeleton-tab"></div>
                        </div>
                        <div className="skeleton-requirements-list">
                            {[...Array(6)].map((_, idx) => (
                                <div key={idx} className="skeleton-requirement-card">
                                    <div className="skeleton-bullet"></div>
                                    <div className="skeleton-text"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                );

            case 'canvas':
                return (
                    <div className="skeleton-canvas">
                        <div className="skeleton-canvas-message">
                            <div className="skeleton-canvas-icon"></div>
                            <div className="skeleton-canvas-text"></div>
                            <div className="skeleton-canvas-text short"></div>
                        </div>
                    </div>
                );

            case 'line':
                return (
                    <div
                        className={`skeleton skeleton-line ${className}`}
                        style={{ height: height || '16px', width: width || '100%' }}
                    ></div>
                );

            case 'text':
                return (
                    <div className={`skeleton skeleton-text ${className}`}>
                        {[...Array(count)].map((_, idx) => (
                            <div
                                key={idx}
                                className="skeleton-text-line"
                                style={{
                                    height: height || '14px',
                                    width: idx === count - 1 ? '60%' : '100%'
                                }}
                            ></div>
                        ))}
                    </div>
                );

            case 'rectangle':
                return (
                    <div
                        className={`skeleton skeleton-rectangle ${className}`}
                        style={{ height: height || '100px', width: width || '100%' }}
                    ></div>
                );

            default:
                return (
                    <div
                        className={`skeleton skeleton-default ${className}`}
                        style={{ height: height || '20px', width: width || '100%' }}
                    ></div>
                );
        }
    };

    return renderSkeleton();
}

export default SkeletonLoader;
